import React from "react";
import { Switch, Route } from "react-router-dom";
import ProfileOverview from "../profile-overview";

const ProfileContainer = () => {
  return (
    <Switch>
      <Route path="/account/profile/" component={ProfileOverview} />
    </Switch>
  );
};

export default ProfileContainer;
